import React, {useEffect} from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import LookRoomPreset from "./lookRoomPreset";
import MaterialSpinner from "../../ui/materialSpinner";
import {getCommonVisualizerType} from "../../../config";
import {getVisualizerTypeFromSubscription} from "../../../misc/visualizerSwitchingFunctions";
import {getBvPresets} from "../../../actions/visualizerFunctions";

const LookRoomsMain = (props) => {

  const {bvPresets, visualizersLoadedLength, hideOverlay, fabricatorData, getBvPresets, allVisualizersPresets,
    requestedVisualizerPresets} = props;

  const commonVisualizerType = getCommonVisualizerType();
  const useWizSwitching = fabricatorData?.settings?.allowVisualizerSwitching && fabricatorData?.fabricatorSubscriptions;

  useEffect(() => {
    if (!useWizSwitching) {
      return
    }
    fabricatorData.fabricatorSubscriptions.forEach(subscription => {
      const subscriptionType = subscription.service.toLowerCase();
      if (commonVisualizerType === subscriptionType) { // already loaded
        return
      }
      const visType = getVisualizerTypeFromSubscription(subscription);
      getBvPresets(subscriptionType, visType);
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fabricatorData]);

  if (!visualizersLoadedLength
    || (useWizSwitching && requestedVisualizerPresets.some(visualizerType => !allVisualizersPresets[visualizerType]))) {
    return (
      <div className="ll-main">
        <MaterialSpinner/>
      </div>
    )
  }

  const sortedBvPresets = fabricatorData?.settings?.allowVisualizerSwitching
    ? Object.keys(allVisualizersPresets)
      .sort((a, b) => {
        if (a === document.kvConfig.visualizerType) return -1;
        if (b === document.kvConfig.visualizerType) return 1;
        return 0;
      })
      .reduce((total, key) => [...total, ...allVisualizersPresets[key]], [])
    : bvPresets

  // console.log("bvPresets", bvPresets);

  return (
    <div className="ll-main">
      <ul className="ll-layouts ll-rooms">
        {sortedBvPresets.map((roomPreset, lookIndex) => {
          return <LookRoomPreset key={lookIndex} roomPreset={roomPreset} hideOverlay={hideOverlay}/>
        })}
      </ul>
    </div>
  )
};

LookRoomsMain.propTypes = {
  hideOverlay: PropTypes.func,
}

const mapStateToProps = (store) => {
  const {visualizersLoaded} = store.serverState;
  const {bvPresets, allVisualizersPresets, requestedVisualizerPresets} = store.bathroomVisualizerState;
  return {
    bvPresets,
    allVisualizersPresets,
    requestedVisualizerPresets,
    visualizersLoadedLength: visualizersLoaded.length,
    fabricatorData: store.fabricatorState,
  };
};

const mapDispatchToProps = {
  getBvPresets,
};

export default connect(mapStateToProps, mapDispatchToProps)(LookRoomsMain)

